export const breakpoints = {
  sm: "320px",
  md: "768px",
  lg: "860px",
  xl: "900px",
  xxl: "1536px",
}
